import { a as rem, i as _responsive, n as _getArrayProp } from "./helpers-bwfx1e-Y.js";
import { t as getTheme_v2 } from "./getTheme_v2-y09KqtEb.js";
import { v as responsiveRadiusStyle, y as Box } from "./useLayer-BAVfmbNN.js";
import { n as Text } from "./stack-C2HKTF-l.js";
import { c } from "react/compiler-runtime";
import { Children, useEffect } from "react";
import { css, styled } from "styled-components";
import { Fragment as Fragment$1, jsx } from "react/jsx-runtime";
import { useEffectEvent } from "use-effect-event";
/**
* Adds global keydown event listener to the window.
*
* @param onKeyDown - The function to call when a keydown event is triggered.
* @param options - The options to pass to the addEventListener function (example, capture: true)
* @beta
*/
function useGlobalKeyDown(onKeyDown, options) {
	let $ = c(7), t0;
	$[0] === onKeyDown ? t0 = $[1] : (t0 = (event) => onKeyDown(event), $[0] = onKeyDown, $[1] = t0);
	let handleKeyDown = useEffectEvent(t0), t1;
	$[2] !== handleKeyDown || $[3] !== options ? (t1 = () => {
		let handler = (event_0) => handleKeyDown(event_0);
		return window.addEventListener("keydown", handler, options), () => window.removeEventListener("keydown", handler, options);
	}, $[2] = handleKeyDown, $[3] = options, $[4] = t1) : t1 = $[4];
	let t2;
	$[5] === options ? t2 = $[6] : (t2 = [options], $[5] = options, $[6] = t2), useEffect(t1, t2);
}
function inlineBaseStyle() {
	return {
		lineHeight: "0",
		"&&:not([hidden])": { display: "block" },
		"& > div": {
			display: "inline-block",
			verticalAlign: "middle"
		}
	};
}
function inlineSpaceStyle(props) {
	let { media, space } = getTheme_v2(props.theme);
	return _responsive(media, props.$space, (spaceIndex) => {
		let _space = rem(spaceIndex === .5 ? space[1] / 2 : space[spaceIndex]);
		return {
			margin: `-${_space} 0 0 -${_space}`,
			"& > div": { padding: `${_space} 0 0 ${_space}` }
		};
	});
}
const StyledInline = /* @__PURE__ */ styled(Box).withConfig({
	displayName: "StyledInline",
	componentId: "sc-3d6tow-0"
})(inlineBaseStyle, inlineSpaceStyle);
function InlineComponent(props) {
	let $ = c(16), as, childrenProp, gap, ref, restProps;
	$[0] === props ? (as = $[1], childrenProp = $[2], gap = $[3], ref = $[4], restProps = $[5]) : ({as, children: childrenProp, gap, ref, ...restProps} = props, $[0] = props, $[1] = as, $[2] = childrenProp, $[3] = gap, $[4] = ref, $[5] = restProps);
	let t0;
	$[6] === childrenProp ? t0 = $[7] : (t0 = Children.map(childrenProp, _temp), $[6] = childrenProp, $[7] = t0);
	let children = t0, t1;
	$[8] === gap ? t1 = $[9] : (t1 = _getArrayProp(gap), $[8] = gap, $[9] = t1);
	let t2;
	return $[10] !== as || $[11] !== children || $[12] !== ref || $[13] !== restProps || $[14] !== t1 ? (t2 = /* @__PURE__ */ jsx(StyledInline, {
		"data-ui": "Inline",
		...restProps,
		$space: t1,
		forwardedAs: as,
		ref,
		children
	}), $[10] = as, $[11] = children, $[12] = ref, $[13] = restProps, $[14] = t1, $[15] = t2) : t2 = $[15], t2;
}
/**
* The `Inline` component is a layout utility for aligning and spacing items horizontally.
*
* @public
*/
function _temp(child) {
	return child && /* @__PURE__ */ jsx("div", { children: child });
}
const Inline = InlineComponent;
function kbdStyle() {
	return css`--card-bg-color:var(--card-kbd-bg-color);--card-border-color:var(--card-kbd-border-color);--card-fg-color:var(--card-kbd-fg-color);box-shadow:inset 0 0 0 1px var(--card-border-color);background:var(--card-bg-color);font:inherit;vertical-align:top;&:not([hidden]){display:inline-block;}`;
}
const StyledKBD = /* @__PURE__ */ styled.kbd.withConfig({
	displayName: "StyledKBD",
	componentId: "sc-26eizu-0"
})(responsiveRadiusStyle, kbdStyle);
function KBDComponent(props) {
	let $ = c(20), children, ref, restProps, t0, t1, t2;
	$[0] === props ? (children = $[1], ref = $[2], restProps = $[3], t0 = $[4], t1 = $[5], t2 = $[6]) : ({children, fontSize: t0, padding: t1, radius: t2, ref, ...restProps} = props, $[0] = props, $[1] = children, $[2] = ref, $[3] = restProps, $[4] = t0, $[5] = t1, $[6] = t2);
	let fontSize = t0 === void 0 ? 0 : t0, padding = t1 === void 0 ? 1 : t1, radius = t2 === void 0 ? 2 : t2, t3;
	$[7] === radius ? t3 = $[8] : (t3 = _getArrayProp(radius), $[7] = radius, $[8] = t3);
	let t4;
	$[9] !== children || $[10] !== fontSize ? (t4 = /* @__PURE__ */ jsx(Text, {
		as: "span",
		size: fontSize,
		weight: "semibold",
		children
	}), $[9] = children, $[10] = fontSize, $[11] = t4) : t4 = $[11];
	let t5;
	$[12] !== padding || $[13] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, {
		as: "span",
		padding,
		children: t4
	}), $[12] = padding, $[13] = t4, $[14] = t5) : t5 = $[14];
	let t6;
	return $[15] !== ref || $[16] !== restProps || $[17] !== t3 || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsx(StyledKBD, {
		"data-ui": "KBD",
		...restProps,
		$radius: t3,
		ref,
		children: t5
	}), $[15] = ref, $[16] = restProps, $[17] = t3, $[18] = t5, $[19] = t6) : t6 = $[19], t6;
}
/**
* Used to define some text as keyboard input.
*
* @public
*/
const KBD = KBDComponent, StyledHotkeys = styled.kbd.withConfig({
	displayName: "StyledHotkeys",
	componentId: "sc-wyylgm-0"
})`font:inherit;padding:1px;&:not([hidden]){display:block;}`, Key = styled(KBD).withConfig({
	displayName: "Key",
	componentId: "sc-wyylgm-1"
})`&:not([hidden]){display:block;}`;
/**
* Represent hotkeys (a keyboard combination) with semantic `<kbd>` elements.
*
* @public
*/
function Hotkeys(props) {
	let $ = c(27), fontSize, keys, padding, radius, ref, restProps, t0;
	$[0] === props ? (fontSize = $[1], keys = $[2], padding = $[3], radius = $[4], ref = $[5], restProps = $[6], t0 = $[7]) : ({fontSize, gap: t0, keys, padding, radius, ref, ...restProps} = props, $[0] = props, $[1] = fontSize, $[2] = keys, $[3] = padding, $[4] = radius, $[5] = ref, $[6] = restProps, $[7] = t0);
	let gap = t0 === void 0 ? .5 : t0, t1;
	$[8] === gap ? t1 = $[9] : (t1 = _getArrayProp(gap), $[8] = gap, $[9] = t1);
	let spacing = t1;
	if (!keys || keys.length === 0) {
		let t2;
		return $[10] === Symbol.for("react.memo_cache_sentinel") ? (t2 = /* @__PURE__ */ jsx(Fragment$1, {}), $[10] = t2) : t2 = $[10], t2;
	}
	let t2;
	if ($[11] !== fontSize || $[12] !== keys || $[13] !== padding || $[14] !== radius) {
		let t3;
		$[16] !== fontSize || $[17] !== padding || $[18] !== radius ? (t3 = (key, i) => /* @__PURE__ */ jsx(Key, {
			fontSize,
			padding,
			radius,
			children: key
		}, i), $[16] = fontSize, $[17] = padding, $[18] = radius, $[19] = t3) : t3 = $[19], t2 = keys.map(t3), $[11] = fontSize, $[12] = keys, $[13] = padding, $[14] = radius, $[15] = t2;
	} else t2 = $[15];
	let t3;
	$[20] !== spacing || $[21] !== t2 ? (t3 = /* @__PURE__ */ jsx(Inline, {
		as: "span",
		gap: spacing,
		children: t2
	}), $[20] = spacing, $[21] = t2, $[22] = t3) : t3 = $[22];
	let t4;
	return $[23] !== ref || $[24] !== restProps || $[25] !== t3 ? (t4 = /* @__PURE__ */ jsx(StyledHotkeys, {
		"data-ui": "Hotkeys",
		...restProps,
		ref,
		children: t3
	}), $[23] = ref, $[24] = restProps, $[25] = t3, $[26] = t4) : t4 = $[26], t4;
}
export { useGlobalKeyDown as i, KBD as n, Inline as r, Hotkeys as t };

//# sourceMappingURL=hotkeys-Bvex-n5O.js.map